/**
 * ProjectButton Component
 */

import { linkWithCurrentQueryString } from '../../../../utils/router';
import { IProjectItemProps } from '../form';
import './project-button.scss';

import { Link } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';

import { ProjectPagePath } from '../';
import Button from '../../../atoms/buttons/Button';
import { IconProjectBox, IconTrash, IconUserAdd } from '../../../atoms/images/Icon';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';

interface IOwnProps extends IProjectItemProps {
  index: number;
  onDelete(id: string): void;
  onSelect(id: string): void;
  onShare(): void;
}

type ProjectButtonProps = IOwnProps & IDispatchProps;

const classes = new BEM({ name: 'project-button', outputIsString: true });

class ProjectButton extends React.Component<ProjectButtonProps, {}> {
  onSelect = () => {
    this.props.onSelect(this.props.id);
  }

  onDelete = () => {
    this.props.onDelete(this.props.id);
  }

  render() {
    return (
      <Link
        to={linkWithCurrentQueryString(ProjectPagePath(this.props.id))}
        activeClassName={classes('', 'active')}
        className={classes()}
        onClick={this.onSelect}
      >
        <IconProjectBox className={classes('icon')} />
        <div className={classes('info')}>
          <Heading
            is="h5"
            text={this.props.title}
            maxTextLength={25}
            noMargin
            className={classes('title')}
          />
          <Span variant="note" size="medium" className={classes('subtitle')}>{this.props.subtitle}</Span>
        </div>
        {this.props.userIsOwner && (
          <div className={classes('actions')}>
            {!this.props.isPublic && <Button
              onClick={this.props.onShare}
              variant="icon"
              icon={<IconUserAdd />}
              className={classes('project-action')}
            />}
            <Button
              onClick={this.onDelete}
              variant="icon"
              icon={<IconTrash />}
              className={classes('project-action')}
              dangerous
            />
          </div>
        )}
      </Link>
    );
  }
}

const ConnectedProjectButton = connect()(ProjectButton);

export default ConnectedProjectButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Projects/projectList/ProjectButton.tsx